import lottie from "lottie-web"
import acSingleMonthAnimation from "../../animations/ac-single-month-gift.json"
import exitIntentPopup from "../exitIntentPopup"
import apiDietPaymentProcessor from "../apiDietPaymentProcessor"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

const ABANDONED_CART_PATH = "abandoned-basket"

export default (getView) =>
  ({ nextStepPath, successStepPath, failedStepPath, exitIntentPath, activeStepPath }) => ({
    ...getView(nextStepPath),
    ...exitIntentPopup(exitIntentPath),

    offers: [],
    activeOffer: null,
    paymentError: false,
    successStepPath: successStepPath,
    failedStepPath: failedStepPath,
    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),

    init() {
      this.commonInit()

      // Init Klaviyo user and track page, cause u can start tracking after init only. Not to miss any events ^^
      this.internalTracker.isUserIdentified({}, "klaviyo").then((isIdentified) => {
        if (!isIdentified) {
          this.internalTracker.trackIdentify({
            customData: { email: this.store.values.email },
            destinationService: "klaviyo",
            callBackFn: () => {
              this.internalTracker.trackPageView({}, "klaviyo")
            },
          })
        }
      })

      lottie.loadAnimation({
        container: document.querySelector("#gift-animation"),
        animationData: acSingleMonthAnimation,
        renderer: "svg",
        loop: true,
        autoplay: true,
      })

      if (this.shouldInitializeAbandonedCartState()) {
        this.initializeAbandonedCartState()
      }

      this.store.values.isUpsell = false
      const basicOffers = pipelineConfig.offers.filter((offer) => this.store.isBasicOffer(offer))
      const offers = basicOffers.sort((a, b) => a.customData.sequence - b.customData.sequence)
      this.offers = offers
      this.activeOffer = offers[0]

      this.setActiveOffer()
      this.initExitIntentPopup()
    },

    // Helper functions
    submitBasicPayment(paymentMethod) {
      const trackingEventNames = {
        primer: "Credit Card Submitted",
        google_pay: "Google Pay Selected",
        apple_pay: "Apple Pay Selected",
        paypal_recurring: "PayPal Selected",
      }
      const clickName = trackingEventNames[paymentMethod] || paymentMethod
      this.internalTracker.trackClick({ clickName })

      this.store.values.lastPaymentMethod = paymentMethod
      this.loading = true

      const { handleCheckoutAndRedirect } = apiDietPaymentProcessor
      const checkoutParams = {
        successStepPath: this.successStepPath,
        failedStepPath: this.failedStepPath,
        paymentMethod: paymentMethod,
        restrictCardSave: true,
        checkoutTemplate: "cf-ac-pipe",
      }

      handleCheckoutAndRedirect(checkoutParams)
    },

    getStandardPrice() {
      return this.store.getFormattedPrice(this.activeOffer.customData.total_price)
    },

    async setActiveOffer() {
      await this.store.setActiveOffer(this.activeOffer)
    },

    // Abandoned cart state initialization
    shouldInitializeAbandonedCartState() {
      return (
        activeStepPath.includes(ABANDONED_CART_PATH) && !this.store.values.isAbandonedCartViewed
      )
    },

    async initializeAbandonedCartState() {
      Object.assign(this.store.values, {
        isAbandonedCartViewed: true,
        exitIntent: false,
        showDiscountModal: false,
      })

      await this.store.push()
    },
  })
